"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../errors");
/**
 * Returns a promise which errors after t seconds.
 *
 * @param t Timeout in seconds.
 * @param taskName Name of task being timed for logging and error reporting.
 */
const timedPromise = (t, taskName) => new Promise((_res, reject) => {
    setTimeout(() => {
        const e = `${taskName} timed out after ${t} seconds.`;
        reject(new errors_1.LDTimeoutError(e));
    }, t * 1000);
});
exports.default = timedPromise;
//# sourceMappingURL=timedPromise.js.map